import { InitAdapter, SubmitAdapter } from '../../types';
import { GallerySelectItem } from '../../common/GalleryMultiselect';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';
import { PapiGallection } from '@wix/da-papi-types';

export const initAdapter: InitAdapter = (
  { galleries: allGalleries = [], inGalleries = [], deviation },
  { isEdit, isDraft, isPresetsForm },
  defaultValues
): GallerySelectItem[] | undefined => {
  const defaultFolderId = defaultValues?.folderId;
  const isSelected = (gallery: PapiGallection) => {
    if (inGalleries.length > 0) {
      // if galleries were provided, always use those
      return inGalleries.some(g => g.folderId === gallery.folderId);
    } else if (!(
      isEdit || isDraft || isPresetsForm || deviation?.isDreamsofart
    )) {
      // if this is a new form and a folderid was given, use that
      if (defaultFolderId) {
        return defaultFolderId === gallery.folderId;
      }
    }
    return false;
  };

  return allGalleries
    .filter(gallery => {
      // Filter out premium folders. Leave "watchers-only" and regular folders.
      const { isPremium, isWatchToAccess } = normalizePremiumFolderData(
        gallery.premiumFolderData
      );
      return isPresetsForm || isWatchToAccess || !isPremium;
    })
    .map(gallery => ({
      gallery,
      value: `${gallery.folderId}`,
      selected: isSelected(gallery),
    }));
};

export const submitAdapter: SubmitAdapter = ({
  galleries = [],
  premiumGalleries = [],
}) => ({
  galleryids: galleries
    .concat(premiumGalleries)
    .filter(item => item.selected)
    .map(({ value }) => value),
});
